import React, {useEffect} from "react";

import axios from "axios";

import {useNavigate, useParams} from "react-router-dom";

function StripeLoading() {
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (!id) {
            navigate('/');
            return;
        }
        axios.get(`${process.env.REACT_APP_API_URL}/transactions/payment-link/${id}`)
            .then((res) => {
                window.location.replace(res.data.url)
            }).catch(() => {
            navigate('/');
        });
    }, [])

    return <div></div>
}

export default StripeLoading;
